import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Zap, BarChart3, Users, Settings, Monitor, ChevronRight } from 'lucide-react'
import { PageHeader, fadeUp } from '@personic/shared'
import { buildBreadcrumbs } from '@/config/routes'

export default function EngageDashboard() {
  const breadcrumbs = buildBreadcrumbs('/engage/dashboard')

  const links = [
    { label: 'Monitor', href: '/tenant/engage/monitor', desc: 'Live session monitoring', icon: Monitor },
    { label: 'Personas', href: '/tenant/engage/personas', desc: 'Engage persona management', icon: Users },
    { label: 'Relationships', href: '/tenant/engage/relationships', desc: 'Profile relationships', icon: BarChart3 },
    { label: 'Settings', href: '/tenant/engage/settings', desc: 'Engage configuration', icon: Settings },
  ]

  return (
    <div>
      <PageHeader
        title="Engage Dashboard"
        description="Real-time customer intelligence and conversation management."
        breadcrumbs={breadcrumbs}
      />

      <motion.div variants={fadeUp} initial="hidden" animate="visible" className="max-w-4xl">
        <div className="rounded-xl border border-warm-200 bg-white p-6 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-lg bg-copper-50 flex items-center justify-center">
              <Zap className="w-5 h-5 text-copper-500" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-midnight-800">Engage Module</h2>
              <p className="text-xs text-warm-500">Full Engage redesign coming in Phase 2</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {links.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="flex items-center justify-between p-4 rounded-xl border border-warm-200 bg-white hover:border-copper-300 transition-colors group"
            >
              <div className="flex items-center gap-3">
                <link.icon className="w-4 h-4 text-warm-400 group-hover:text-copper-500" />
                <div>
                  <p className="text-sm font-medium text-midnight-800 group-hover:text-copper-700">{link.label}</p>
                  <p className="text-xs text-warm-500">{link.desc}</p>
                </div>
              </div>
              <ChevronRight className="w-4 h-4 text-warm-300 group-hover:text-copper-500" />
            </Link>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
